import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  Icon,
  ModalBasement,
  ModalContainer,
  ToastService,
} from '@millionshow/client-libs';

@Component({
  selector: 'app-admin-auth-modal',
  templateUrl: './admin-auth.modal.html',
  imports: [CommonModule, ModalContainer, Icon, ReactiveFormsModule],
})
export class AdminAuthModal extends ModalBasement<any> {
  private readonly toastService = inject(ToastService);

  form = new FormGroup({
    password: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
  });

  submit(): void {
    if (this.form.invalid) {
      return;
    }

    const { password } = this.form.getRawValue();

    if (password === '1234') {
      this.close(true);
    } else {
      this.toastService.error('비밀번호가 일치하지 않습니다.');
    }
  }
}
